import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.styl']
})
export class PopupComponent implements OnInit {
  @Input() display: boolean;
  @Output() displayChange: EventEmitter<boolean> = new EventEmitter;

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit() {
  }

  @HostListener('document:mousedown', ['$event']) onDocumentMouseDown(event: MouseEvent) {
    if (this.elementRef.nativeElement.contains(event.target)) {
      return;
    }

    this.displayChange.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/popup/popup.component.ts